const destinationTypes = {
  instantVideo: 'meeting/video',
  videoAppointment: 'appointment',
  plan: 'subscribe',
} as const;

export type DestinationType = keyof typeof destinationTypes;

type Destination = {
  type: DestinationType;
  speciality?: number;
  planId?: string;
};

type DestinationParams = Destination;

const mapDestinationType = (key: keyof typeof destinationTypes) =>
  destinationTypes[key];

const subscribePath = (planId: string) => `${destinationTypes.plan}/${planId}`;

export const useDestination = () => {
  return (params: DestinationParams) => {
    const {type, planId} = params;
    if (type === 'plan') return `/${subscribePath(planId!)}`;

    const {speciality} = params;
    const base = mapDestinationType(type);
    return `/${base}/${speciality}/${planId ? subscribePath(planId) : 'pay'}`;
  };
};
